import request from "./request.js";
import baseUrl from "./config.js"
// import qs from "qs";

// 示例
// export function login(params) {
// 	// let formData = new FormData(); // 创建form对象
// 	// formData.append('presentFormInfoVO', params);
// 	return request({
// 		url: baseUrl + "/spider/web/login",
// 		method: "post",
// 		data: params
// 	});
// 	//其实，也不一定就是params，也可以是 query 还有 data 的呀！
// 	//params是添加到url的请求字符串中的，用于get请求。会将参数加到 url后面。所以，传递的都是字符串。无法传递参数中含有json格式的数据
// 	//而data是添加到请求体（body）中的， 用于post请求。添加到请求体（body）中，json 格式也是可以的。
// }

//获取当前IP
export function getIp() {
	return request({
		url: `https://api.ipify.org/`,
		method: "get",
	});
}

// 助教消息获取
export function getNotice(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getNotice`,
		method: "get",
		params: params
	});
}

// 官员消息获取
export function getOfficialNotice(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getNotice`,
		method: "get",
		params: params
	});
}

// 助教消息详情
export function checkNotice(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/checkNotice`,
		method: "get",
		params: params
	});
}

// 官员消息详情
export function checkNotOfficial(params) {
	return request({
		url: `${baseUrl}/sign/live/official/checkNotice`,
		method: "get",
		params: params
	});
}

// 地图相关请求
export function getMapFun(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/getLocation`,
		method: "get",
		params: params
	});
}

// 登录
export function login(params) {
	return request({
		url: `${baseUrl}/api/auth/login`,
		method: "post",
		data: {
			phone: params.phoneNumber || params.phone,
			password: params.password
		}
	});
}

// 生成【查看合同】的免登录访问链接 https://wmzh.test.life-oasis.com/api
export function fetchSettlementViewUrl(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/settlement/generate-view-url`,
		method: "post",
		data: params
	});
}


// 设置初始密码
export function initPassword(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/initPassword`,
		method: "post",
		data: params
	});
}

// 获取项目信息
export function getProjectById(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getProjectById`,
		method: "get",
		params: params
	});
}
export function officialGetProjectById(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getProjectById`,
		method: "get",
		params: params
	});
}

// 删除会议
export function delMeeting(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/delMeeting`,
		method: "post",
		data: params
	});
}
export function officialDelMeeting(params) {
	return request({
		url: `${baseUrl}/sign/live/official/delMeeting`,
		method: "post",
		data: params
	});
}

// 发送手机验证码
export function sendCode(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/sendCode/${params.phone}?id=${params.id}`,
		method: "get",
	});
}

// 我的项目 (统一接口)
export function projectList(params) {
	return request({
		url: `${baseUrl}/api/project/list`,
		method: "get",
		params: params
	});
}
// 按项目查会议列表
export function getMeetingList(params) {
	return request({
		url: `${baseUrl}/api/meeting/list`,
		method: "get",
		params: params
	});
}
// 企业人员管理
export function addProjectSponsor(projectId, data) {
	return request({
		url: `${baseUrl}/api/project/${projectId}/sponsor`,
		method: "post",
		data: data
	});
}
export function getProjectSponsors(projectId) {
	return request({
		url: `${baseUrl}/api/project/${projectId}/sponsors`,
		method: "get"
	});
}
export function removeProjectSponsor(projectId, sponsorId) {
	return request({
		url: `${baseUrl}/api/project/${projectId}/sponsor/${sponsorId}`,
		method: "delete"
	});
}
// 我的项目 (助教)
export function newProjectList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/newProjectList`,
		method: "get",
		params: params
	});
}




// 我的项目 (官员 - 统一接口)
export function oprojectList(params) {
	return request({
		url: `${baseUrl}/api/project/list`,
		method: "get",
		params: params
	});
}


export function newOfficialProjectList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/newOfficialProjectList`,
		method: "get",
		params: params
	});
}






// 新增患教用户
export function addExecutiveUser(data) {
	return request({
		url: `${baseUrl}/sign/live/official/addExecutiveUser`,
		method: 'post',
		data: data
	})
}


// 我的项目 (医生)
export function dprojectList(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/projectList`,
		method: "get",
		params: params
	});
}

export function getProjectList(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/getProjectList`,
		method: "get",
		params: params
	});
}

// 助教查询医生参与项目列表
export function doctorProjectList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/doctorProjectList`,
		method: "get",
		params: params
	});
}
// 官员查询医生参与项目列表
export function doctorOfficialProjectList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/doctorProjectList`,
		method: "get",
		params: params
	});
}

// 助教获取今日项目
export function todayMeeting(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/todayMeeting`,
		method: "get",
		params: params
	});
}
// 官员获取今日项目
export function officialTodayMeeting(params) {
	return request({
		url: `${baseUrl}/sign/live/official/todayMeeting`,
		method: "get",
		params: params
	});
}

// 助教获取进入会议的链接
export function getMeetingUrl(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getMeetingUrl`,
		method: "get",
		params: params
	});
}
// 官员获取进入会议的链接
export function ogetMeetingUrl(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getMeetingUrl`,
		method: "get",
		params: params
	});
}

// 新注册用户审核
export function examineUser(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/examineUser`,
		method: "post",
		data: params
	});
}

// 查询会后待上传数量
export function uploadMeetingNum(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getUploadMeetingNum`,
		method: "get",
		params: params
	});
}
export function officialMeetingNum(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getUploadMeetingNum`,
		method: "get",
		params: params
	});
}

// 获取会议列表 (助教)
export function meetList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/meetingList`,
		method: "get",
		params: params
	});
}
// 获取会议列表 (官员)
export function officialMeetList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/meetingList`,
		method: "get",
		params: params
	});
}
//官员查看会议列表
export function orderMeetingListBOfficial(params) {
	return request({
		url: `${baseUrl}/sign/live/official/orderMeetingList`,
		method: "get",
		params: params
	});
}
//官员查看会议列表
export function getOrderMeetingListByOrderId(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getOrderMeetingListByOrderId`,
		method: "get",
		params: params
	});
}


export function orderMeetingList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/orderMeetingList`,
		method: "get",
		params: params
	});
}

// 保存会后文件
export function saveMeetingFile(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/saveMeetingFile`,
		method: "post",
		data: params
	});
}

// 上传会后文件
export function uploadMeetingFile(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/uploadMeetingFile`,
		method: "post",
		data: params
	});
}

// 官员保存会后文件
export function officialSaveMeetingFile(params) {
	return request({
		url: `${baseUrl}/sign/live/official/saveMeetingFile`,
		method: "post",
		data: params
	});
}
// 官员上传会后文件
export function officialUploadMeetingFile(params) {
	return request({
		url: `${baseUrl}/sign/live/official/uploadMeetingFile`,
		method: "post",
		data: params
	});
}

// 获取待审核医生列表   waitDoctors
export function waitDoctors(params) {
	return request({
		url: `${baseUrl}/sign/live/official/waitDoctors`,
		method: "get",
		params: params
	});
}

// 删除会后上传文件
export function delMeetingFile(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/delMeetingFile`,
		method: "get",
		params: params
	});
}

// 官员删除会后上传文件
export function officialDelMeetingFile(params) {
	return request({
		url: `${baseUrl}/sign/live/official/delMeetingFile`,
		method: "get",
		params: params
	});
}

// 助教会议上传资料回显
export function doctorGetMeetingFile(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/getMeetingFile`,
		method: "get",
		params: params
	});
}

// 助教会议上传资料回显
export function getMeetingFile(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getMeetingFile`,
		method: "get",
		params: params
	});
}

// 官员会议上传资料回显
export function officialMeetingFile(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getMeetingFile`,
		method: "get",
		params: params
	});
}

// 医生端 获取会议列表（新接口，根据登录用户自动筛选）
export function doctorMeetList(params) {
	return request({
		url: `${baseUrl}/api/meeting/my`,
		method: "get",
		params: params
	});
}

// 医生端 今日会议
export function doctorTodayMeeting(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/todayMeeting`,
		method: "get",
		params: params
	});
}

// 获取待签署协议
export function getAgreementNum(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/getAgreementNum`,
		method: "get",
		params: params
	});
}

// 进会前签到
export function signIn(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/signIn`,
		method: "post",
		data: params
	});
}

// 手动结束会议
export function meetingOver(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/meetingOver`,
		method: "post",
		data: params
	});
}
export function officialMeetingOver(params) {
	return request({
		url: `${baseUrl}/sign/live/official/meetingOver`,
		method: "post",
		data: params
	});
}

// 医生获取会议链接
export function doctorGetMeetingUrl(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/getMeetingUrl`,
		method: "get",
		params: params
	});
}

// 医生获取会议详情
export function getMeetDetil(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/getUpdateMeetingById`,
		method: "get",
		params: params
	});
}

// 助教获取会议详情
export function getUpdateMeetInfo(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getUpdateMeetingById`,
		method: "get",
		params: params
	});
}
export function officialGetUpdateMeetInfo(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getUpdateMeetingById`,
		method: "get",
		params: params
	});
}

// 获取执行机构列表
export function getOrgList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/actuatorList`,
		method: "get",
		params: params
	});
}

export function officialActuatorList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/actuatorList`,
		method: "get",
		params: params
	});
}

// 更新会议进入
export function updateMeetingStatus(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/updateMeetingStatus`,
		method: "post",
		data: params
	});
}

// 立项单位列表
export function getMechanismList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/mechanismList`,
		method: "get",
		params: params
	});
}
export function officialtMechanismList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/mechanismList`,
		method: "get",
		params: params
	});
}

//支持企业列表
export function getSupportList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/supportList`,
		method: "get",
		params: params
	});
}

// 查询部门内人员列表
export function getAssistantUserList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/assistantUserList`,
		method: "get",
		params: params
	});
}
export function getofficialUserList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/assistantUserList`,
		method: "get",
		params: params
	});
}
export function exportTemplatebyProID(params) {
	return request({
		url: `${baseUrl}/sign/live/official/exportTemplatebyProID`,
		method: "get",
		params: params,
		responseType: 'blob'

	});
}
// 通过项目ID查询助教
export function projectAssistantUserList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/projectAssistantUserList`,
		method: "get",
		params: params
	});
}
// 助教获取会议详情
export function getEnterPriseList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/enterPriseList`,
		method: "get",
		params: params
	});
}
export function officialEnterPriseList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/enterPriseList`,
		method: "get",
		params: params
	});
}

// 医生查询项目角色列表
export function roleList(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/getMeetingRoleList`,
		method: "get",
		params: params
	});
}

// 官员查询项目角色列表
export function officialRoleList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getMeetingRoleList`,
		method: "get",
		params: params
	});
}

// 助教查询项目角色列表 /sign/live/assistant/getProjectRoleList
export function getroleList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getProjectRoleList`,
		method: "get",
		params: params
	});
}

export function getMeetRoleList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getMeetingRoleList`,
		method: "get",
		params: params
	});
}
export function officialGetMeetRoleList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getMeetingRoleList`,
		method: "get",
		params: params
	});
}

// 获取会议详情
export function meetingMessage(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/getMeetingMessage`,
		method: "get",
		params: params
	});
}

// 医生签署协议/sign/live/doctor/startSign
export function startSign(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/startSign`,
		method: "post",
		data: params
	});
}

// 官员获取用户信息列表
export function meetingUserInfoList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/meetingUserInfoList`,
		method: "get",
		params: params
	});
}

//助教用户信息列表
export function meetUserInfoList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/meetingUserInfoList`,
		method: "get",
		params: params
	});
}

// 查询用户上传的文件
export function getUserFileList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/userFileList`,
		method: "get",
		params: params
	});
}

// 助教查询用户上传的文件
export function AgetUserFileList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/userFileList`,
		method: "get",
		params: params
	});
}

// 医生调取劳务列表
export function orderList(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/orderList`,
		method: "get",
		params: params
	});
}
export function officialOrderList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/orderList`,
		method: "get",
		params: params
	});
}

// 助教调取劳务列表
export function orderListAssistant(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/orderList`,
		method: "get",
		params: params
	});
}

// 官员会议列表
export function officialMeetingList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getOfficialMeetingList`,
		method: "get",
		params: params
	});
}

// 官员会议详情
export function officialMeetingDetail(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getOfficialMeetingDetail`,
		method: "get",
		params: params
	});
}

//查看会议协议签署情况
export function getAgreementList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/agreementList`,
		method: "get",
		params: params
	});
}

// 官员查看会议协议签署情况
export function officialAgreementList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/agreementList`,
		method: "get",
		params: params
	});
}

// 获取医生用户信息
export function getDoctorInfo(params) {
	return request({
		url: `${baseUrl}/api/auth/getUserInfo`,
		method: "get",
		params: params
	});
}

// 获取官员用户信息
export function getOfficialInfo(params) {
	return request({
		url: `${baseUrl}/api/auth/getUserInfo`,
		method: "get",
		params: params
	});
}

//官员查询供应商结算单
export function getSpendingOrderListByPage(params) {
	return request({
		url: `${baseUrl}/sign/live/official/spendingOrderList`,
		method: "get",
		params: params
	});
}

export function fetchStatusCounts(params) {
	return request({
		url: `${baseUrl}/sign/live/official/fetchStatusCounts`,
		method: "get",
		params: params
	});
}



//官员审核结算单
export function examineSpendingOrder(params) {
	return request({
		url: `${baseUrl}/sign/live/official/examineSpendingOrder`,
		method: "post",
		data: params
	});
}




//供应算结算-批量审核文件（通过）
export const batchAuditPass = (fileIds) => {
	return request({
		url: `${baseUrl}/sign/live/official/batch/pass`,
		method: 'post',
		data: { fileIds }
	});
};
//供应算结算-批量审核文件（批量失败）
export const batchAuditReject = (fileIds, reason) => {
	return request({
		url: `${baseUrl}/sign/live/official/batch/reject`,
		method: 'post',
		data: { fileIds, reason }
	});
};





// 获取助教用户信息
export function getAssistantInfo(params) {
	return request({
		url: `${baseUrl}/api/auth/getUserInfo`,
		method: "get",
		params: params
	});
}

// 助教获取立项单位公告
export function assistantGetMechanismNotice(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getMechanismNotice`,
		method: "get",
		params: params
	});
}

// 官员获取立项单位公告
export function officialGetMechanismNotice(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getMechanismNotice`,
		method: "get",
		params: params
	});
}

// 医生参与的项目数量和会议数量
export function getMyProjectNumAndMeetingNum(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/getMyProjectNumAndMeetingNum`,
		method: "get",
		params: params
	});
}

export function getMeetingNum(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getMyProjectNumAndMeetingNum`,
		method: "get",
		params: params
	});
}

// 注册医生用户
export function register(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/register`,
		method: "post",
		data: params
	});
}

// 修改密码
export function changePassword(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/changePassword`,
		method: "post",
		data: params
	});
}
// /sign/live/assistant/changePassword
export function changeAssistantPwd(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/changePassword`,
		method: "post",
		data: params
	});
}

// 注册用户信息
export function information(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/information`,
		method: "post",
		data: params
	});
}

// 助教修改医生信息
export function changeInfobyId(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/information`,
		method: "post",
		data: params
	});
}
// 官员修改医生信息
export function changeOfficialInfobyId(params) {
	return request({
		url: `${baseUrl}/sign/live/official/information`,
		method: "post",
		data: params
	});
}

// 获取医生列表
export function doctorList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getDoctorList`,
		method: "get",
		params: params
	});
}
export function officialGetDoctorList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getDoctorList`,
		method: "get",
		params: params
	});
}

// 根据Id获取医生信息
export function getDoctorById(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getDoctorById`,
		method: "get",
		params: params
	});
}
// 根据Id获取医生信息
export function getOfficialDoctorById(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getDoctorById`,
		method: "get",
		params: params
	});
}

// 获取签署协议模板列表
export function getTemplate(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getTemplate`,
		method: "get",
		params: params
	});
}

// 发送签属协议的短信
export function sendText(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/sendText`,
		method: "post",
		data: params
	});
}
export function officialSendText(params) {
	return request({
		url: `${baseUrl}/sign/live/official/sendText`,
		method: "post",
		data: params
	});
}

// 新建会议
export function createMeeting(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/createMeeting`,
		method: "post",
		data: params
	});
}
export function officialCreateMeeting(params) {
	return request({
		url: `${baseUrl}/sign/live/official/createMeeting`,
		method: "post",
		data: params
	});
}

// 修改会议
export function updateMeeting(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/updateMeeting`,
		method: "post",
		data: params
	});
}
export function officialUpdateMeeting(params) {
	return request({
		url: `${baseUrl}/sign/live/official/updateMeeting`,
		method: "post",
		data: params
	});
}

// 上传会议KV与海报  修改会议海报及背景图
export function updateMeetingImage(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/updateMeetingImage`,
		method: "post",
		data: params
	});
}

// 回显会议详情
export function getMeetingById(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getMeetingById`,
		method: "get",
		params: params
	});
}

// 重新发起审核
export function reapply(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/reapply`,
		method: "post",
		data: params
	});
}

// 导入项目用户
export function importProjectUser(params) {
	return request({
		url: `${baseUrl}/sign/live/official/importProjectUser`,
		method: "post",
		data: params
	});
}

// 官员审核会议材料 确认无误后提交财务审核
export function examineOfficialMeeting(params) {
	return request({
		url: `${baseUrl}/sign/live/official/examineOfficialMeeting`,
		method: "post",
		data: params
	});
}

// 导入明细信息
export function getSheetData(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getSheetData`,
		method: "post",
		data: params
	});
}

//获取明细内文件夹内文件列表
export function getProjectConfig(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getProjectConfigByType`,
		method: "GET",
		params: params
	});
}


//获取明细内文件夹内文件列表
export function getProjectConfigWithOfficial(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getProjectConfigByType`,
		method: "GET",
		params: params
	});
}


// 保存或修改结算单
export function saveUpdateOrder(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/saveOrUpdateOrder`,
		method: "post",
		data: params
	});
}
export function saveOrder(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/saveOrder`,
		method: "post",
		data: params
	});
}

// 获取结算单信息 通过会议ID
export function getOrderByMeetId(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getOrderByMeetingId`,
		method: "get",
		params: params
	});
}
export function getOrderById(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getOrderById`,
		method: "get",
		params: params
	});
}
export function getLatestByProjectId(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getLatestByProjectId`,
		method: "get",
		params: params
	});
}



export function getOrderByIdWithOfficial(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getOrderById`,
		method: "get",
		params: params
	});
}



//会议收款方式
export function getProjectCollectWay(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getProjectCollectWay`,
		method: "get",
		params: params
	});
}
export function getCollectWay(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getCollectWay`,
		method: "get",
		params: params
	});
}

//新的助教结算
export function getCollectWayNew(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getCollectWayNew`,
		method: "get",
		params: params
	});
}

export function officialGetCollectWay(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getCollectWay`,
		method: "get",
		params: params
	});
}

// 获取明细内文件夹列表
export function getDetailFolders(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getDetailFolders`,
		method: "get",
		params: params
	});
}

// 获取明细内文件夹列表
export function getDetailFoldersWithOfficial(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getDetailFolders`,
		method: "get",
		params: params
	});
}

// 获取指定类型下的明细类型
export function getFolderById(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getFolderById`,
		method: "get",
		params: params
	});
}

// 官员获取指定类型下的明细类型
export function getFolderByIdWithOffcial(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getFolderById`,
		method: "get",
		params: params
	});
}

// 提交明细内文件夹内文件列表
export function submitFiles(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/submitDetailFolderFiles`,
		method: "post",
		data: params
	});
}
export function reUploadDetailFolderFile(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/reUploadDetailFolderFile`,
		method: "post",
		data: params
	});
}



// 获取明细内文件夹内文件列表
export function getFiles(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getDetailFolderAndFiles`,
		method: "get",
		params: params
	});
}

// 获取明细内文件夹内文件列表
export function getFilesWithOffcial(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getDetailFolderAndFiles`,
		method: "get",
		params: params
	});
}

// 新增或修改明细内文件夹
export function saveOrUpdateFolder(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/saveOrUpdateDetailFolder`,
		method: "post",
		data: params
	});
}

// 新增或修改明细内文件夹
export function delFolderAndFiles(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/delFolderAndFiles`,
		method: "post",
		data: params
	});
}


// 下载文件
export function downloadFile(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/downloadFolder`,
		method: "get",
		params: params,
		responseType: 'blob',
		timeout: 100 * 1000
	});
}
//下载指定支出明细下的文件
export function downloadDetailFolder(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/downloadDetailFolder`,
		method: "get",
		params: params,
		responseType: 'blob',
		timeout: 100 * 1000
	});
}
//下载指定支出明细下的文件
export function downloadDetailFolderBYOfficial(params) {
	return request({
		url: `${baseUrl}/sign/live/official/downloadDetailFolder`,
		method: "get",
		params: params,
		responseType: 'blob',
		timeout: 100 * 1000
	});
}


export function downloadProjectFiles(params) {
	return request({
		url: `${baseUrl}/sign/live/official/downloadProjectFiles`,
		method: "get",
		params: params,
		responseType: 'blob',
		timeout: 100 * 1000
	});
}




// 确认协议
export function editOrderView(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/editOrderView`,
		method: "post",
		params: params
	});
}

// 删除明细
export function delDetail(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/delDetail`,
		method: "post",
		params: params
	});
}

// 提交结算单
export function submitOrder(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/submitOrder`,
		method: "post",
		params: params
	});
}
export function uploadOrder(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/uploadOrder`,
		method: "post",
		data: params
	});
}

// 获取回款记录明细
export function getOrdersByProjectId(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getOrdersByProjectId`,
		method: "get",
		params: params
	});
}

// 更新会议文件
export function updateMeetingFile(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/updateMeetingFile`,
		method: "post",
		data: params
	});
}
export function officialUpdateMeetingFile(params) {
	return request({
		url: `${baseUrl}/sign/live/official/updateMeetingFile`,
		method: "post",
		data: params
	});
}


// 获取会议审批流
export function approvalProcess(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getApprovalProcess`,
		method: "get",
		params: params
	});
}
export function officialApprovalProcess(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getApprovalProcess`,
		method: "get",
		params: params
	});
}

// 供应商结算 金额变化自动保存
export function editFolderMoney(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/editFolderMoney`,
		method: "post",
		data: params
	});
}

// 助教获取劳务明细
export function meetingOrderList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/meetingOrderList`,
		method: "get",
		params: params
	});
}

// 下载劳务明细
export function exportYzfOrder(params) {
	return request({
		url: `${baseUrl}/sign/live/official/exportYzfOrder`,
		method: "get",
		params: params,
		responseType: 'blob',
		timeout: 100 * 1000
	});
}

// 删除视频
export function delMeetingVideo(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/delMeetingVideo`,
		method: "post",
		data: params
	});
}

export function delOfficialMeetingVideo(params) {
	return request({
		url: `${baseUrl}/sign/live/official/delMeetingVideo`,
		method: "post",
		data: params
	});
}

// 官员确认批量创建会议
export function saveProjectMeeting(params) {
	return request({
		url: `${baseUrl}/sign/live/official/saveProjectMeeting`,
		method: "post",
		data: params
	});
}

// 官员获取项目配额列表
export function ProjectAssistantTaskList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getProjectAssistantTaskList`,
		method: "get",
		params: params
	});
}
// 为助教添加系列会建会配额
export function addProjectAssistantTask(params) {
	return request({
		url: `${baseUrl}/sign/live/official/addProjectAssistantTask`,
		method: "post",
		data: params
	});
}

// 保存助教信息
export function saveProjectAssistant(params) {
	return request({
		url: `${baseUrl}/sign/live/official/saveProjectAssistant`,
		method: "post",
		data: params
	});
}

// 修改用户信息
export function updateProjectUser(params) {
	return request({
		url: `${baseUrl}/sign/live/official/updateProjectUser`,
		method: "post",
		data: params
	});
}

// 助教认领项目
export function claimProject(params) {
	return request({
		url: `${baseUrl}/sign/live/official/claimProject`,
		method: "post",
		data: params
	});
}

// 助教获取地区列表
export function getLocationListass(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getLocationList`,
		method: "get",
		data: params
	});
}

// 官员获取地区列表
export function getLocationList(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getLocationList`,
		method: "get",
		data: params
	});
}


// 获取常用模板
export function getTemplateList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getTemplateList`,
		method: "get",
		data: params
	});
}

// 助教获取公告
export function getProjectNotice(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getProjectNotice`,
		method: "get",
		params: params
	});
}
// 官员获取公告
export function officialGetProjectNotice(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getProjectNotice`,
		method: "get",
		params: params
	});
}

// 助教确认公告内容
export function acceptProjectNotice(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/acceptProjectNotice`,
		method: "post",
		data: params
	});
}

// 官员确认公告内容
export function officialacceptProjectNotice(params) {
	return request({
		url: `${baseUrl}/sign/live/official/acceptProjectNotice`,
		method: "post",
		data: params
	});
}

// 设置修改公告
export function saveOrUpdateProjectNotice(params) {
	return request({
		url: `${baseUrl}/sign/live/official/saveOrUpdateProjectNotice`,
		method: "post",
		data: params
	});
}

// 官员下载所有的劳务协议
export function officialdownloadAgreement(params) {
	return request({
		url: `${baseUrl}/sign/live/official/downloadAgreement`,
		method: "get",
		params: params,
		responseType: 'blob',
		timeout: 100 * 1000
	});
}

// 官员下载所有的劳务协议
export function officialddownloadAllFile(params) {
	return request({
		url: `${baseUrl}/sign/live/official/downloadAll`,
		method: "get",
		params: params,
		responseType: 'blob',
		timeout: 100 * 1000
	});
}

// 助教下载劳务协议
export function downloadAgreementAss(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/downloadAgreement`,
		method: "get",
		params: params,
		responseType: 'blob',
		timeout: 100 * 1000
	});
}

// 获取当前账号关联的立项单位
export function getMyMechanism(params) {
	return request({
		url: `${baseUrl}/api/auth/getMyMechanism`,
		method: "get",
		params: params
	});
}

// 修改当前的立项单位
export function editMechanism(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/editMechanism`,
		method: "post",
		data: params
	});
}

// 官员获取当前账号关联的立项单位
export function officialGetMyMechanism(params) {
	return request({
		url: `${baseUrl}/api/auth/getMyMechanism`,
		method: "get",
		params: params
	});
}

// 官员修改当前的立项单位
export function officialEditMechanism(params) {
	return request({
		url: `${baseUrl}/sign/live/official/editMechanism`,
		method: "post",
		data: params
	});
}

// 助教获取压缩包内文件
export function assistantGetZipFile(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getZipFile`,
		method: "get",
		params: params
	});
}

// 官员获取压缩包内文件
export function officialGetZipFile(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getZipFile`,
		method: "get",
		params: params
	});
}

//官员根据ID获取导入订单
export function officialGetImportOrderById(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getImportOrderById`,
		method: "get",
		params: params
	});
}

//助教根据ID获取导入订单
export function getImportOrderById(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getImportOrderById`,
		method: "get",
		params: params
	});
}

// 官员修改导入支付订单
export function officialEditImportOrderMessage(params) {
	return request({
		url: `${baseUrl}/sign/live/official/editImportOrderMessage`,
		method: "post",
		data: params
	});
}
// 助教修改导入支付订单
export function editImportOrderMessage(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/editImportOrderMessage`,
		method: "post",
		data: params
	});
}

// 官员删除导入支付订单
export function officialDeleteImportOrder(params) {
	return request({
		url: `${baseUrl}/sign/live/official/delImportOrder`,
		method: "post",
		data: params
	});
}
// 助教删除导入支付订单
export function delImportOrder(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/delImportOrder`,
		method: "post",
		data: params
	});
}

// 助教获取项目内会议各个类型的数量
export function assistantGetProjectMeetingNum(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getProjectMeetingNum`,
		method: "get",
		params: params
	});
}

// 官员获取项目内会议各个类型的数量
export function officialGetProjectMeetingNum(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getProjectMeetingNum`,
		method: "get",
		params: params
	});
}


// 官员获取项目各个状态的数量
export function getProjectStatusNum(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getProjectStatusNum`,
		method: "get",
		params: params
	});
}

// 助教获取项目各个状态的数量
export function assistantGetProjectStatusNum(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getProjectStatusNum`,
		method: "get",
		params: params
	});
}

// 助教获取金蝶费用项目列表
export function getExpenseItem(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getExpenseItem`,
		method: "get",
		params: params
	});
}

// 官员获取金蝶费用项目列表
export function officialGetExpenseItem(params) {
	return request({
		url: `${baseUrl}/sign/live/official/getExpenseItem`,
		method: "get",
		params: params
	});
}

//医生在个人详情界面获取当前的劳务协议信息
export function getDoctorAgreement(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/getMeetingAgreement`,
		method: "get",
		params: params
	});
}

// 医生在个人详情界面提交本场会议发票
export function submitMeetingInvoice(params) {
	return request({
		url: `${baseUrl}/sign/live/doctor/submitInvoice`,
		method: "post",
		data: params
	});
}



// 供应商单号查询全部文件
export function queryFile(params) {
	return request({
		url: `${baseUrl}/sign/live/official/queryFile`,
		method: "get",
		params: params
	});
}
export function annotateFolder(params) {
	return request({
		url: `${baseUrl}/sign/live/official/annotateFolder`,
		method: "post",
		data: params
	});
}
export function annotateFile(params) {
	return request({
		url: `${baseUrl}/sign/live/official/annotateFile`,
		method: "post",
		data: params
	});
}
//供应商结算的日志记录查询
export function listOrderLog(params) {
    return request({
        url: `${baseUrl}/spending/orderLog/list`,
        method: 'get',
        params: params
    })
}
//助教查询会议所对应的文件夹列表
export function getSpendFolderListByMeetingId(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/getSpendFolderListByMeetingId`,
		method: 'post',
		data: params
	})
}

export function allSpendFolderList(params) {
	return request({
		url: `${baseUrl}/sign/live/assistant/allSpendFolderList`,
		method: 'get',
		params: params
	})
}

export function allSpendFolderListOfOfficial(params) {
	return request({
		url: `${baseUrl}/sign/live/official/allSpendFolderList`,
		method: 'get',
		params: params
	})
}

export function getSpendingOrderFileLogList(params) {
	return request({
		url: `${baseUrl}/spending-order-file-log/list`,
		method: 'get',
		params: params
	})
}


//查询文件夹的审核规则内容
export function getAuditRules(params) {
	return request({
		url: `${baseUrl}/sign/live/official/audit-rules`,
		method: "get",
		params: params
	});
}

//查询文件夹的审核规则内容
export function updateApplyNo(params) {
	return request({
		url: `${baseUrl}/sign/live/official/updateApplyNo`,
		method: 'post',
		data: params
	});
}


//跳转到金蝶
export function redirctUrl(params) {
	return request({
		url: `${baseUrl}/sign/live/official/redirctUrl`,
		method: "get",
		params: params
	});
}

//同步金蝶状态
export function kingdeeStatus(params) {
	return request({
		url: `${baseUrl}/sign/live/official/kingdeeStatus`,
		method: "get",
		params: params
	});
}
//同步金蝶付款日期
export function syncPaymentDate(params) {
	return request({
		url: `${baseUrl}/sign/live/official/paymentDate`,
		method: "get",
		params: params
	});
}

// =====================================================
// 新后端结算 API（/api/spending）
// =====================================================

/** 获取结算单详情（含明细+材料） */
export function getSpendingOrderDetail(orderId) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/detail`,
		method: "get",
	});
}

/** 结算单列表(支持 settlementType 过滤 + 返回 JOIN 字段) */
export function getSpendingOrderList(params) {
	return request({
		url: `${baseUrl}/api/spending/list`,
		method: "get",
		params: params
	});
}

/** 结算单各状态数量统计 */
export function getSpendingStatusCounts(settlementType) {
	return request({
		url: `${baseUrl}/api/spending/status-counts`,
		method: "get",
		params: settlementType ? { settlementType } : {}
	});
}

/** 结算单审核时间线(AI + 人工合并) */
export function getSpendingAuditHistory(orderId) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/audit-history`,
		method: "get",
	});
}

/** 机构下拉(精简, 仅 id+orgName+orgType, 响应更快) */
export function getOrgListNew(params) {
	return request({
		url: `${baseUrl}/api/org/options`,
		method: "get",
		params: params
	});
}

/** 查询某会议关联的结算单(用于判断会议是否已结算) */
export function getSpendingByMeeting(meetingId) {
	return request({
		url: `${baseUrl}/api/spending/meeting/${meetingId}`,
		method: "get",
	});
}

/** 批量查会议结算状态 (用于会议列表卡片显示发起结算/进度按钮) */
export function batchMeetingSettlementStatus(meetingIds) {
	return request({
		url: `${baseUrl}/api/spending/batch-meeting-status`,
		method: "post",
		data: meetingIds || []
	});
}

/** G7: 标记材料文件需重传(单文件级驳回, 不退回整单) */
export function markSpendingFolderIssue(folderId, reason) {
	return request({
		url: `${baseUrl}/api/spending/material/${folderId}/mark-issue`,
		method: "post",
		data: { reason }
	});
}

// =====================================================
// G9 消息通知
// =====================================================

export function getNotificationList(params) {
	return request({
		url: `${baseUrl}/api/notification/list`,
		method: "get",
		params: params
	});
}

export function getNotificationUnreadCount() {
	return request({
		url: `${baseUrl}/api/notification/unread-count`,
		method: "get",
	});
}

export function markNotificationRead(id) {
	return request({
		url: `${baseUrl}/api/notification/${id}/mark-read`,
		method: "post",
	});
}

export function markAllNotificationsRead() {
	return request({
		url: `${baseUrl}/api/notification/mark-all-read`,
		method: "post",
	});
}

/** 提交结算单 */
export function submitSpendingOrder(orderId) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/submit`,
		method: "post",
	});
}

/** 审核通过 */
export function approveSpendingOrder(orderId) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/approve`,
		method: "post",
	});
}

/** 审核驳回 */
export function rejectSpendingOrder(orderId, reason) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/reject`,
		method: "post",
		params: { reason }
	});
}

/** 创建结算单 */
export function createSpendingOrder(data) {
	return request({
		url: `${baseUrl}/api/spending/create`,
		method: "post",
		data: data
	});
}

/** 添加费用明细 */
export function addSpendingItem(orderId, data) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/item`,
		method: "post",
		data: data
	});
}

/** 删除费用明细 */
export function removeSpendingItem(itemId) {
	return request({
		url: `${baseUrl}/api/spending/item/${itemId}`,
		method: "delete",
	});
}

/** 添加材料文件 */
export function addSpendingFolder(orderId, data) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/folder`,
		method: "post",
		data: data
	});
}

/** 按费用类型查材料列表 */
export function getSpendingFolders(orderId, feeType) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/folders`,
		method: "get",
		params: feeType ? { feeType } : {}
	});
}

/** 推送金蝶 */
export function pushSpendingToK3(orderId) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/push-k3`,
		method: "post",
	});
}

/** 劳务费税后计算 */
export function calcSpendingTax(amount) {
	return request({
		url: `${baseUrl}/api/spending/tax`,
		method: "get",
		params: { amount }
	});
}

// =====================================================
// 新后端项目 API（/api/project）
// =====================================================

/** 项目列表（带结算单关联） */
export function getProjectListNew(params) {
	return request({
		url: `${baseUrl}/api/project/list`,
		method: "get",
		params: params
	});
}

/** 按项目ID查最新结算单 */
export function getLatestOrderByProject(projectId) {
	return request({
		url: `${baseUrl}/api/project/${projectId}/latestOrder`,
		method: "get",
	});
}

/** 收款方式选项 */
export function getCollectWayOptions() {
	return request({
		url: `${baseUrl}/api/project/collectWayOptions`,
		method: "get",
	});
}

// ==================== 多级审核 API ====================

/** 官员审核通过（带操作人信息） */
export function officialApproveOrder(orderId, params) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/official-approve`,
		method: "post",
		data: params
	});
}

/** 官员审核驳回（含文件级描述） */
export function officialRejectOrder(orderId, params) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/official-reject`,
		method: "post",
		data: params
	});
}

/** 财务审核通过 */
export function financeApproveOrder(orderId, params) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/finance-approve`,
		method: "post",
		data: params
	});
}

/** 财务审核驳回 */
export function financeRejectOrder(orderId, params) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/finance-reject`,
		method: "post",
		data: params
	});
}

// ==================== 审核日志 API ====================

/** 查询结算单审核日志 */
export function getAuditLogs(params) {
	return request({
		url: `${baseUrl}/api/audit-log/list`,
		method: "get",
		params: params
	});
}

/** 按阶段查询审核日志 */
export function getAuditLogsByStage(params) {
	return request({
		url: `${baseUrl}/api/audit-log/list-by-stage`,
		method: "get",
		params: params
	});
}

/** 查询结算单的 AI 审核结果(含任务摘要+违规明细) */
export function getSpendingAiAudit(orderId) {
	return request({
		url: `${baseUrl}/api/spending/${orderId}/ai-audit`,
		method: "get",
	});
}

// ==================== 会议签署 API ====================

/** 添加医生到会议（创建签署记录，支持预填） */
export function addDoctorToMeeting(params) {
	return request({
		url: `${baseUrl}/api/meeting-sign/add-doctor`,
		method: "post",
		data: params
	});
}

/** 医生完成签署 */
export function completeSigning(recordId, signFilePath) {
	return request({
		url: `${baseUrl}/api/meeting-sign/${recordId}/complete`,
		method: "post",
		params: { signFilePath }
	});
}

/** 查询会议签署记录 */
export function getMeetingSignRecords(meetingId) {
	return request({
		url: `${baseUrl}/api/meeting-sign/meeting/${meetingId}`,
		method: "get",
	});
}

/** 查询医生签署历史 */
export function getDoctorSignHistory(phone) {
	return request({
		url: `${baseUrl}/api/meeting-sign/doctor/${phone}`,
		method: "get",
	});
}

/** 查询会议签署统计 */
export function getMeetingSignStats(meetingId) {
	return request({
		url: `${baseUrl}/api/meeting-sign/stats/${meetingId}`,
		method: "get",
	});
}

// ==================== 会议直播功能模块 API ====================

/** 入场验证（返回是否需要填表单 + 历史数据回填） */
export function verifyMeetingEntry(meetingId, phone) {
	return request({
		url: `${baseUrl}/api/meeting/${meetingId}/verify-entry`,
		method: "post",
		params: { phone }
	});
}

/** 提交入场表单 */
export function submitEntryForm(meetingId, data) {
	return request({
		url: `${baseUrl}/api/meeting/${meetingId}/submit-entry-form`,
		method: "post",
		data: data
	});
}

/** 获取会议自定义表单字段 */
export function getFormFields(meetingId) {
	return request({
		url: `${baseUrl}/api/meeting/${meetingId}/form-fields`,
		method: "get"
	});
}

/** 查询直播状态 */
export function getLiveStatus(meetingId) {
	return request({
		url: `${baseUrl}/api/meeting/${meetingId}/live/status`,
		method: "get"
	});
}

/** 获取录制回放地址 */
export function getReplayUrl(meetingId) {
	return request({
		url: `${baseUrl}/api/meeting/${meetingId}/live/replay`,
		method: "get"
	});
}

/** 获取在线人数（真实+虚拟） */
export function getOnlineCount(meetingId) {
	return request({
		url: `${baseUrl}/api/meeting/${meetingId}/online-count`,
		method: "get"
	});
}

/** 获取 TRTC 入会凭证 */
export function getTrtcCredential(userId, roomId) {
	return request({
		url: `${baseUrl}/api/trtc/credential`,
		method: "get",
		params: { userId, roomId }
	});
}

/** 创建 TRTC 房间（主持人调用） */
export function createTrtcRoom(meetingId, title) {
	return request({
		url: `${baseUrl}/api/trtc/room/create`,
		method: "post",
		data: { meetingId, title }
	});
}

/** 结束 TRTC 会议 */
export function endTrtcRoom(meetingId, recordTaskId) {
	return request({
		url: `${baseUrl}/api/trtc/room/end`,
		method: "post",
		data: { meetingId, recordTaskId }
	});
}

/** 开始会议（后端创建TRTC房间+更新状态） */
export function startMeeting(meetingId) {
	return request({
		url: `${baseUrl}/api/meeting/${meetingId}/start`,
		method: "post"
	});
}

/** 结束会议 */
export function endMeeting(meetingId) {
	return request({
		url: `${baseUrl}/api/meeting/${meetingId}/end`,
		method: "post"
	});
}

/** 获取会议详情 */
export function getMeetingDetail(meetingId) {
	return request({
		url: `${baseUrl}/api/meeting/${meetingId}`,
		method: "get"
	});
}

// ==================== 会议证据 API ====================

/** 获取会议全部证据（按类型分组） */
export function getEvidenceList(meetingId) {
	return request({
		url: `${baseUrl}/api/evidence/${meetingId}`,
		method: "get"
	});
}

/** 获取截图列表 */
export function getScreenshots(meetingId) {
	return request({
		url: `${baseUrl}/api/evidence/${meetingId}/screenshots`,
		method: "get"
	});
}

/** 获取录制文件列表 */
export function getRecordings(meetingId) {
	return request({
		url: `${baseUrl}/api/evidence/${meetingId}/recordings`,
		method: "get"
	});
}

/** 获取签到报告 */
export function getAttendanceReport(meetingId) {
	return request({
		url: `${baseUrl}/api/evidence/${meetingId}/attendance`,
		method: "get"
	});
}

/** 手动触发一次截图 */
export function captureScreenshot(meetingId) {
	return request({
		url: `${baseUrl}/api/evidence/${meetingId}/screenshot`,
		method: "post"
	});
}

/** 设置截图为 H5 封面 */
export function setScreenshotAsCover(meetingId, imageUrl) {
	return request({
		url: `${baseUrl}/sign/live/assistant/setCoverImage`,
		method: "post",
		data: { meetingId, coverImageUrl: imageUrl }
	});
}

/** 删除截图 */
export function deleteScreenshot(evidenceId) {
	return request({
		url: `${baseUrl}/api/evidence/${evidenceId}`,
		method: "delete"
	});
}

/** 删除录制记录 */
export function deleteRecordingEvidence(evidenceId) {
	return request({
		url: `${baseUrl}/api/evidence/${evidenceId}`,
		method: "delete"
	});
}

/** 切换录制文件 H5 可见性 */
export function toggleRecordingVisibility(evidenceId, visible) {
	return request({
		url: `${baseUrl}/api/evidence/${evidenceId}/visible`,
		method: "put",
		params: { visible }
	});
}

/** 修改录制文件显示名称 */
export function renameRecordingEvidence(evidenceId, fileName) {
	return request({
		url: `${baseUrl}/api/evidence/${evidenceId}/rename`,
		method: "put",
		params: { fileName }
	});
}
